import React, { useState } from 'react';
import './style.scss';
import clsx from 'clsx';
import SVGWarningIcon from '../../../assets/images/icons/warning';
import useWeb3 from '../../../contexts/web3';

interface Props {
  name: string;
  inverted: boolean;
  className: string;
}

const AppHeaderImproperNetwork = ({ name, className, inverted }: Props) => {
  const [loading, setLoading] = useState(false);
  const { handleMetamaskClick } = useWeb3();

  const handleClick = () => {
    setLoading(true);
    handleMetamaskClick(
      () => {},
      'Proceed',
      () => setLoading(false)
    );
  };

  return (
    <div
      className={clsx('ah-improper-network', inverted && 'inverted', className)}
    >
      <SVGWarningIcon className='ah-improper-network-icon' size={32} />
      <div className='ah-improper-network-content'>
        <div className='title'>{name} isn't supported</div>
        <span
          className={clsx('action', loading && 'text-loading')}
          onClick={handleClick}
        >
          switch to {process.env.REACT_APP_CHAIN_NAME}
        </span>
      </div>
    </div>
  );
};

export default AppHeaderImproperNetwork;
